var TorsoView = require('backbone-torso/modules/View');
var receiptSummaryAccordionTemplate = require('./receiptSummaryAccordionTriggerTemplate.hbs');

 /**
  * A trigger view for the receipt summary accordion that includes the number of receipts.
  *
  * @class ReceiptSummaryAccordionView
  * @constructor
  * @param options {Object} Options to configure this view.
  *   @param options.receiptSummaryListWidget {ReceiptSummaryListWidget} used to determine the receipt count to display.
  * @extends Torso.View
  */
 module.exports = TorsoView.extend({
  tagName: 'span',
  template: receiptSummaryAccordionTemplate,

   prepareFields: {
     receiptCount: function() {
       return this._receiptSummaryListWidget.receiptCount();
     }
   },

  /**
   * @method initialize
   * @param options {Object} Options to configure this view.
   *   @param options.receiptSummaryListWidget {ReceiptSummaryListWidget} used to determine the receipt count to display.
   * @override
   */
  initialize: function(options) {
    this._receiptSummaryListWidget = options.receiptSummaryListWidget;
  }
});
